export default __webpack_public_path__ + "static/media/range@2x.67018950.png";